import ApiService, { status } from '@/services/ApiService';
import Vue from 'vue';
import store from '@/store';
export default {
  getAll() {
    return ApiService().post('/bill/list', {lastPing: store.state.bill.lastPing});
  },

  getPrintData(id, mode = 0, noProductGroup = 0, groupedItemBill=false) {
    if (groupedItemBill) {
      return ApiService().get(`/bill/${id}/${mode}/${noProductGroup}?groupedItemBill=true`);
    }
    return ApiService().get(`/bill/${id}/${mode}/${noProductGroup}`);
  },
  
  getPrintProductGroupTicket(id) {
    return ApiService().post('/bill/print-product-group-ticket', { id });
  },

  getBill(id) {
    return ApiService().get(`/bill/${id}/4`);
  },

  post(bill) {
    const action = bill.id ? 'update' : 'new';
    const method = bill.id ? 'put' : 'post';
    // todo: check shift status / day status when not access through login root
    /* eslint-disable */
    return ApiService()[method](`/bill/${action}`, bill);
    /* eslint-enable */
  },

  closeBill({id, payDetails}) {
    return ApiService()
      .patch(`/bill/close/${id}`, payDetails);
  },

  voidBill(id, statusNote) {
    return ApiService()
      .patch(`/bill/void/${id}`, {statusNote});
  },

  splitBill(data) {
    return ApiService()
      .post('/bill/split', data);
  },

  mergeBill(firstBill, secondBill, billItems) {
    const cover = 1 * (firstBill.cover ? firstBill.cover : 0) + 1 * (secondBill.cover ? secondBill.cover : 0);
    const newBill = {
            staff: firstBill.staff,
            table: firstBill.table ? firstBill.table : '',
            room: firstBill.room ? firstBill.room : '',
            cover: cover == 0 ? '' : cover,
            customer: firstBill.customer ? firstBill.customer : '',
            billItems
          };
    return ApiService()
      .post(
        '/bill/merge',
        {
          newBill,
          firstBillId: firstBill.id,
          secondBillId: secondBill.id,
        },
      );
  },

  getBillStatus(billStatus) {
    switch (billStatus) {
      case 0:
        return Vue.prototype.$gettext('Open');
      case 1:
        return Vue.prototype.$gettext('Closed');
      default:
        return Vue.prototype.$gettext('Voided');
    }
  },

};
